import {
  Button,
  IconButton,
  Typography,
} from "@braintrust/braintrust-ui-components";
import { CloseIcon } from "@braintrust/braintrust-ui-components/Icons";

import styles from "./styles.module.scss";

type CompleteProfileTopBarComponentProps = {
  showTopBar: boolean;
  onCloseClick: () => void;
  onCompleteProfileClick: () => void;
};

export const CompleteProfileTopBarComponent = ({
  showTopBar,
  onCloseClick,
  onCompleteProfileClick,
}: CompleteProfileTopBarComponentProps) => {
  if (!showTopBar) {
    return null;
  }

  return (
    <div className={styles.completeProfileBar}>
      <Typography
        component="p"
        size="small"
        className={styles.completeProfileBarCopy}
      >
        Unlock the ability for clients to view your profile by getting approved.
        Start with completing your profile.{" "}
        <Button
          variant="no-padding"
          size="x-small"
          fontWeight={400}
          sx={{
            textDecoration: "underline !important",
            verticalAlign: "baseline",
          }}
          onClick={onCompleteProfileClick}
        >
          Complete profile
        </Button>
      </Typography>
      <IconButton
        size="small"
        variant="primary"
        aria-label="Dismiss complete profile bar"
        className={styles.completeProfileBarDismissBtn}
        onClick={onCloseClick}
      >
        <CloseIcon
          sx={{
            borderRadius: "50%",
          }}
        />
      </IconButton>
    </div>
  );
};
